import * as React from "react";
import { Button } from "components/bootstrap";
import { Collapsible, Col, DataWell } from "common/components";
import User from "security-app/components/Assets/AssetModals/AssetDetailsDrawer/UserData";
import Machine from "security-app/components/Assets/AssetModals/AssetDetailsDrawer/MachineData";
const componentByType = {
  machine: (machine) => /* @__PURE__ */ React.createElement(Machine, { machineAsset: machine }),
  user: (user) => /* @__PURE__ */ React.createElement(User, { userAsset: user })
};
const Assets = ({ investigation }) => {
  const { associated_assets } = investigation || {};
  return /* @__PURE__ */ React.createElement(DataWell, { $color: "content", style: { flexGrow: 1 } }, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement("h2", null, "Assets"), /* @__PURE__ */ React.createElement(Col, { $gap: 0 }, !associated_assets || (associated_assets == null ? void 0 : associated_assets.length) < 1 ? /* @__PURE__ */ React.createElement("div", null, "There are no associated assets to show.") : associated_assets == null ? void 0 : associated_assets.map((asset) => /* @__PURE__ */ React.createElement(
    Collapsible,
    {
      key: asset.id,
      title: /* @__PURE__ */ React.createElement(Button, { bsStyle: "link" }, /* @__PURE__ */ React.createElement("b", null, asset.name))
    },
    /* @__PURE__ */ React.createElement(Col, { $gap: "lg" }, componentByType[asset.details.type](asset))
  )))));
};
export default Assets;
